// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__3Wjs8","content":"styles_content__35hGy","checkbox":"styles_checkbox__3Jb63","checkboxLabel":"styles_checkboxLabel__JXpOs"};